import React, { Component } from "react";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";


class Table extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <table className="table clickeable-row-table">
            <TableHeader />
            <TableBody
                tarjetas={this.props.tarjetas}
                modalidadDistribucionLimiteId={this.props.modalidadDistribucionLimiteId}
                limiteCompraCodigo={this.props.limiteCompraCodigo}
            />
        </table>
    }
}

export default Table;